import { Avatar, ListItemButton, ListItemText, Stack } from '@mui/material';
import React from 'react';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

interface SearchItemPropTypes {
    src: string;
    name: string;
    nickName: string;
    onClick: React.MouseEventHandler<HTMLDivElement>;
}

const SearchItem: React.FC<SearchItemPropTypes> = ({ src, name, nickName, onClick }) => {
    return (
        <ListItemButton sx={{ borderBottom: '2px solid #E5E7EB' }}>
            <Stack onClick={onClick} width="100%" direction="row" justifyContent="space-between" alignItems="center">
                <Stack width="50%" direction="row" gap={3} alignItems="center">
                    <Avatar src={src} sx={{ width: 24, height: 24 }} />
                    <ListItemText primary={name} />
                </Stack>
                <ListItemText primary={nickName} />
                <ArrowForwardIosIcon fontSize="small" />
            </Stack>
        </ListItemButton>
    );
};

export default SearchItem;
